/* import __COLOCATED_TEMPLATE__ from './enable-digital-experiences.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type SalesforceConfiguration from 'embercom/models/standalone/salesforce-configuration';
import safeWindowOpen from 'embercom/lib/safe-window-open';

interface Signature {
  Args: {
    accordion: any;
    onContinue?: () => void;
    onCasesChannel?: boolean;
  };
}

export default class EnableDigitalExperiences extends Component<Signature> {
  @service declare finStandaloneService: FinStandaloneService;

  get salesforcePlatform() {
    return this.finStandaloneService.salesforcePlatform;
  }

  get salesforceConfig(): SalesforceConfiguration {
    return this.salesforcePlatform.salesforceConfig!;
  }

  get isDigitalExperiencesEnabled() {
    return this.salesforcePlatform.salesforceSetupData.hasDigitalExperiences;
  }

  @action
  openDigitalExperiencesSettings() {
    safeWindowOpen(this.salesforceConfig.buildLightningSetupUrl('NetworkSettings/home'), '_blank');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Cases::Connect::EnableDigitalExperiences': typeof EnableDigitalExperiences;
  }
}
